import React from 'react';

import {BlockEditorPane} from 'insights/analytics-dashboards/details/view-state/ScreenState';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import ToggleExpandButton from 'ui-library/buttons/ToggleExpandButton';

export default function AnalyticsBlockEditorPaneToggleExpandButton({
  className,
  dataTestAttrs,
  expandedPane,
  onToggleExpandPane,
  pane,
}: {
  className?: string;
  dataTestAttrs?: DataTestAttrs;
  expandedPane: BlockEditorPane | null;
  onToggleExpandPane: (pane: BlockEditorPane, newIsExpanded: boolean) => void;
  pane: BlockEditorPane;
}): JSX.Element {
  return (
    <ToggleExpandButton
      className={className}
      dataTestAttrs={dataTestAttrs}
      isExpanded={expandedPane === pane}
      onChange={(newIsExpanded: boolean) => {
        onToggleExpandPane(pane, newIsExpanded);
      }}
    />
  );
}
